import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type CreateCourseTranslations = {
  [lang: string]: Translation;
};

export const createCourseTranslations: CreateCourseTranslations = {
  en,
};
